<template>
  <div class="api-documentation">
    <a-page-header
      :title="t.pageTitle"
      :sub-title="t.commonRequestPath"
    />

    <a-card :title="t.signatureRule" style="margin-top: 20px;">
      <p>{{ t.signatureDescription }}</p>
    </a-card>

    <a-card :title="t.apiList" style="margin-top: 20px;">
      <a-collapse v-model="activeKey">
        <!-- 添加子账户 -->
        <a-collapse-panel :header="t.addSonAccount" key="1">
          <div class="api-detail">
            <div class="api-path">POST /stage-api/uapi/openapi/addSonAcount</div>
            <div class="api-signature"><strong>{{ t.signatureRule }}：</strong>sign = md5(flow+password+sonname+uid+key)</div>
            <a-divider />
            
            <h4>{{ t.requestExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "sonname": "weawaggwag",\n  "password": "weawaggwag",\n  "flow": "1",\n  "uid": 199,\n  "sign": "908e6e894033eb62adcb987f9210fe04"\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.requestParams }}</h4>
            <a-table
              :columns="requestParamsColumns"
              :data-source="addSonAccountParams"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "msg": "string",\n  "code": 0\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.responseResult }}</h4>
            <a-table
              :columns="responseResultColumns"
              :data-source="responseResults"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseDataStructure }}</h4>
            <a-table
              :columns="responseDataStructureColumns"
              :data-source="addSonAccountResponseData"
              :pagination="false"
              bordered
            />
          </div>
        </a-collapse-panel>
        
        <!-- 添加子账户流量 -->
        <a-collapse-panel :header="t.addSonAccountFlow" key="2">
          <div class="api-detail">
            <div class="api-path">POST /stage-api/uapi/openapi/addcumuflowClient</div>
            <div class="api-signature"><strong>{{ t.signatureRule }}：</strong>sign = md5(flow+sonname+uid+key)</div>
            <a-divider />
            
            <h4>{{ t.requestExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "sonname": "weawaggwag",\n  "flow": "1",\n  "uid": 199,\n  "sign": "908e6e894033eb62adcb987f9210fe04"\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.requestParams }}</h4>
            <a-table
              :columns="requestParamsColumns"
              :data-source="addSonAccountFlowParams"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "msg": "操作成功",\n  "code": 200\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.responseResult }}</h4>
            <a-table
              :columns="responseResultColumns"
              :data-source="responseResults"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseDataStructure }}</h4>
            <a-table
              :columns="responseDataStructureColumns"
              :data-source="commonResponseData"
              :pagination="false"
              bordered
            />
          </div>
        </a-collapse-panel>
        
        <!-- 查询当前登录账号子账号的列表 -->
        <a-collapse-panel :header="t.selectSonAccountList" key="3">
          <div class="api-detail">
            <div class="api-path">POST /stage-api/uapi/openapi/selectSonAccountListClient</div>
            <div class="api-signature"><strong>{{ t.signatureRule }}：</strong>sign = md5(uid+key)</div>
            <a-divider />
            
            <h4>{{ t.requestExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "uid": 111,\n  "sign": "908e6e894033eb62adcb987f9210fe04"\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.requestParams }}</h4>
            <a-table
              :columns="requestParamsColumns"
              :data-source="selectSonAccountListParams"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "msg": "操作成功",\n  "code": 200,\n  "data": [\n    {\n      "createTime": null,\n      "uid": 111,\n      "username": "weawaggwag",\n      "password": "weawag",\n      "consumeFlow": "0",\n      "countFlow": "4"\n    },\n    {\n      "createTime": null,\n      "uid": 111,\n      "username": "esggwggewfa",\n      "password": "esggwg",\n      "consumeFlow": "0",\n      "countFlow": "1"\n    }\n  ]\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.responseResult }}</h4>
            <a-table
              :columns="responseResultColumns"
              :data-source="responseResults"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseDataStructure }}</h4>
            <a-table
              :columns="responseDataStructureColumns"
              :data-source="selectSonAccountListResponseData"
              :pagination="false"
              bordered
            />
          </div>
        </a-collapse-panel>
        
        <!-- 删除子账户 -->
        <a-collapse-panel :header="t.deleteSonAccount" key="4">
          <div class="api-detail">
            <div class="api-path">POST /stage-api/uapi/openapi/delectSonAccount</div>
            <div class="api-signature"><strong>{{ t.signatureRule }}：</strong>sign = md5(sonname+uid+key)</div>
            <a-divider />
            
            <h4>{{ t.requestExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "uid": 111,\n  "sonname": "sonname",\n  "sign": "908e6e894033eb62adcb987f9210fe04"\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.requestParams }}</h4>
            <a-table
              :columns="requestParamsColumns"
              :data-source="deleteSonAccountParams"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "code": 200,\n  "msg": "操作成功"\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.responseResult }}</h4>
            <a-table
              :columns="responseResultColumns"
              :data-source="responseResults"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseDataStructure }}</h4>
            <a-table
              :columns="responseDataStructureColumns"
              :data-source="commonResponseData"
              :pagination="false"
              bordered
            />
          </div>
        </a-collapse-panel>
        
        <!-- 查询子账号15天的流量消耗数据 -->
        <a-collapse-panel :header="t.queryFlowConsumption" key="5">
          <div class="api-detail">
            <div class="api-path">GET /stage-api/uapi/openapi/polyline</div>
            <div class="api-signature"><strong>{{ t.signatureRule }}：</strong>sign = md5(uname+uid+key)</div>
            <a-divider />
            
            <h4>{{ t.requestExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
uname=all&uid=111&sign="908e6e894033eb62adcb987f9210fe04"
            </code></pre>
            <a-divider />
            
            <h4>{{ t.requestParams }}</h4>
            <a-table
              :columns="requestParamsColumns"
              :data-source="polylineParams"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "msg": "操作成功",\n  "code": 200,\n  "data": [\n    {\n      "flowOverdueChange": 0,\n      "createrTime": "2024-08-27"\n    },\n    {\n      "flowOverdueChange": 0,\n      "createrTime": "2024-08-28"\n    }\n  ]\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.responseResult }}</h4>
            <a-table
              :columns="responseResultColumns"
              :data-source="responseResults"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseDataStructure }}</h4>
            <a-table
              :columns="responseDataStructureColumns"
              :data-source="polylineResponseData"
              :pagination="false"
              bordered
            />
          </div>
        </a-collapse-panel>
        
        <!-- 获取子账户代理链接 -->
        <a-collapse-panel :header="t.getProxyList" key="6">
          <div class="api-detail">
            <div class="api-path">GET /stage-api/uapi/openapi/getConsumptionProxyList</div>
            <div class="api-signature"><strong>{{ t.signatureRule }}：</strong>sign = md5(uid + uname + time + country + key)</div>
            <a-divider />
            
            <h4>{{ t.requestExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
uname=test&uid=111&time=5&num=10&country=us&sign="908e6e894033eb62adcb987f9210fe04"
            </code></pre>
            <a-divider />
            
            <h4>{{ t.requestParams }}</h4>
            <a-table
              :columns="requestParamsColumns"
              :data-source="proxyListParams"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "msg": "操作成功",\n  "code": 200,\n  "data": [\n    "ip:port:username:password",\n    "ip:port:username:password"\n  ]\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.responseResult }}</h4>
            <a-table
              :columns="responseResultColumns"
              :data-source="responseResults"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseDataStructure }}</h4>
            <a-table
              :columns="responseDataStructureColumns"
              :data-source="proxyListResponseData"
              :pagination="false"
              bordered
            />
          </div>
        </a-collapse-panel>
      </a-collapse>
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'DynamicApiDoc',
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.currentLanguage : 'en';
    },
    t() {
      const lang = this.currentLanguage;
      return {
        pageTitle: lang === 'zh' ? '动态API接口文档' : 'Dynamic API Documentation',
        commonRequestPath: lang === 'zh' ? '公共请求路径：https://www.proxylink.net/' : 'Common Request Path: https://www.proxylink.net/',
        signatureRule: lang === 'zh' ? '签名规则' : 'Signature Rule',
        signatureDescription: lang === 'zh' ? 'sign: 请求参数按ascii码排序，然后参数+key获取signstr，md5(signStr)获得签名字段sign' : 'sign: Request parameters are sorted by ASCII code, then parameters+key to get signstr, md5(signStr) to get the signature field sign',
        apiList: lang === 'zh' ? 'API列表' : 'API List',
        
        addSonAccount: lang === 'zh' ? 'POST 添加子账户' : 'POST Add Sub-account',
        addSonAccountFlow: lang === 'zh' ? 'POST 添加子账户流量' : 'POST Add Sub-account Flow',
        selectSonAccountList: lang === 'zh' ? 'POST 查询当前登录账号子账号的列表' : 'POST Query Sub-account List of Current Login Account',
        deleteSonAccount: lang === 'zh' ? 'POST 删除子账户' : 'POST Delete Sub-account',
        queryFlowConsumption: lang === 'zh' ? 'GET 查询子账号15天的流量消耗数据' : 'GET Query Sub-account 15-day Flow Consumption Data',
        getProxyList: lang === 'zh' ? 'GET 获取子账号代理链接' : 'GET Get Sub-account Proxy Links',
        
        requestExample: lang === 'zh' ? '请求示例' : 'Request Example',
        requestParams: lang === 'zh' ? '请求参数' : 'Request Parameters',
        responseExample: lang === 'zh' ? '返回示例' : 'Response Example',
        responseResult: lang === 'zh' ? '返回结果' : 'Response Result',
        responseDataStructure: lang === 'zh' ? '返回数据结构' : 'Response Data Structure',
        
        // Table headers
        name: lang === 'zh' ? '名称' : 'Name',
        location: lang === 'zh' ? '位置' : 'Location',
        type: lang === 'zh' ? '类型' : 'Type',
        required: lang === 'zh' ? '必选' : 'Required',
        description: lang === 'zh' ? '说明' : 'Description',
        code: lang === 'zh' ? '状态码' : 'Code',
        message: lang === 'zh' ? '说明' : 'Message',
        model: lang === 'zh' ? '数据模型' : 'Data Model'
      };
    },
    requestParamsColumns() {
      return [
        { title: this.t.name, dataIndex: 'name', key: 'name' },
        { title: this.t.location, dataIndex: 'location', key: 'location' },
        { title: this.t.type, dataIndex: 'type', key: 'type' },
        { title: this.t.required, dataIndex: 'required', key: 'required' },
        { title: this.t.description, dataIndex: 'description', key: 'description' }
      ];
    },
    responseResultColumns() {
      return [
        { title: this.t.code, dataIndex: 'code', key: 'code' },
        { title: this.t.message, dataIndex: 'message', key: 'message' },
        { title: this.t.model, dataIndex: 'model', key: 'model' }
      ];
    },
    responseDataStructureColumns() {
      return [
        { title: this.t.name, dataIndex: 'name', key: 'name' },
        { title: this.t.type, dataIndex: 'type', key: 'type' },
        { title: this.t.required, dataIndex: 'required', key: 'required' },
        { title: this.t.description, dataIndex: 'description', key: 'description' }
      ];
    }
  },
  data() {
    // Default to English for initial data
    const defaultLang = 'en';
    
    return {
      activeKey: ['1'],
      responseResults: [
        { key: '1', code: '200', message: defaultLang === 'zh' ? '成功' : 'Success', model: 'Inline' }
      ],
      
      // 添加子账户请求参数
      addSonAccountParams: [
        { key: '1', name: 'sonname', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '新增子用户的名字' : 'Name of new sub-user' },
        { key: '2', name: 'password', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '新增子用户的密码' : 'Password of new sub-user' },
        { key: '3', name: 'flow', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '要分配给的流量' : 'Flow to be allocated' },
        { key: '4', name: 'uid', location: 'body', type: 'integer', required: '是', description: defaultLang === 'zh' ? '主账户的uid' : 'Main account uid' },
        { key: '5', name: 'sign', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '签名' : 'Signature' }
      ],
      
      // 添加子账户返回数据结构
      addSonAccountResponseData: [
        { key: '1', name: 'msg', type: 'string', required: 'true', description: defaultLang === 'zh' ? '返回消息' : 'Return message' },
        { key: '2', name: 'code', type: 'integer', required: 'true', description: defaultLang === 'zh' ? '状态码' : 'Status code' }
      ],
      
      // 添加子账户流量请求参数
      addSonAccountFlowParams: [
        { key: '1', name: 'flow', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '增加的流量' : 'Increased flow' },
        { key: '2', name: 'uid', location: 'body', type: 'integer', required: '是', description: defaultLang === 'zh' ? '用户的id' : 'User id' },
        { key: '3', name: 'sign', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '签名' : 'Signature' },
        { key: '4', name: 'sonname', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '子用户的名字' : 'Sub-user name' }
      ],
      
      // 查询子账号列表请求参数
      selectSonAccountListParams: [
        { key: '1', name: 'uid', location: 'body', type: 'integer', required: '是', description: defaultLang === 'zh' ? '用户uid' : 'User uid' },
        { key: '2', name: 'sign', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '签名' : 'Signature' }
      ],
      
      // 查询子账号列表返回数据结构
      selectSonAccountListResponseData: [
        { key: '1', name: 'msg', type: 'string', required: 'true', description: defaultLang === 'zh' ? '消息' : 'Message' },
        { key: '2', name: 'code', type: 'integer', required: 'true', description: defaultLang === 'zh' ? '状态码' : 'Status code' },
        { key: '3', name: 'data', type: '[object]', required: 'true', description: defaultLang === 'zh' ? '返回数据' : 'Return data' },
        { key: '4', name: 'createTime', type: 'null', required: 'true', description: defaultLang === 'zh' ? '创建时间' : 'Creation time' },
        { key: '5', name: 'uid', type: 'integer', required: 'true', description: defaultLang === 'zh' ? '用户id' : 'User id' },
        { key: '6', name: 'username', type: 'string', required: 'true', description: defaultLang === 'zh' ? '用户名' : 'Username' },
        { key: '7', name: 'password', type: 'string', required: 'true', description: defaultLang === 'zh' ? '密码' : 'Password' },
        { key: '8', name: 'consumeFlow', type: 'string', required: 'true', description: defaultLang === 'zh' ? '流量消耗' : 'Flow consumption' },
        { key: '9', name: 'countFlow', type: 'string', required: 'true', description: defaultLang === 'zh' ? '流量总量' : 'Total flow' }
      ],
      
      // 删除子账户请求参数
      deleteSonAccountParams: [
        { key: '1', name: 'uid', location: 'query', type: 'string', required: '否', description: defaultLang === 'zh' ? '账户的id' : 'Account id' },
        { key: '2', name: 'sonname', location: 'query', type: 'string', required: '否', description: defaultLang === 'zh' ? '子账户的名字' : 'Sub-account name' },
        { key: '3', name: 'sign', location: 'query', type: 'string', required: '否', description: defaultLang === 'zh' ? '签名' : 'Signature' }
      ],
      
      // 查询子账号15天的流量消耗数据请求参数
      polylineParams: [
        { key: '1', name: 'uname', location: 'query', type: 'string', required: '是', description: defaultLang === 'zh' ? '子账户名称或者all(查询所有的子账号的15天流量变动记录总和)' : 'Sub-account name or all (query the sum of 15-day flow change records for all sub-accounts)' },
        { key: '2', name: 'uid', location: 'query', type: 'integer', required: '是', description: defaultLang === 'zh' ? '登录用户的id' : 'Logged-in user id' },
        { key: '3', name: 'sign', location: 'query', type: 'string', required: '否', description: defaultLang === 'zh' ? '签名' : 'Signature' }
      ],
      
      // 查询子账号15天的流量消耗数据返回数据结构
      polylineResponseData: [
        { key: '1', name: 'msg', type: 'string', required: 'true', description: defaultLang === 'zh' ? '消息' : 'Message' },
        { key: '2', name: 'code', type: 'integer', required: 'true', description: defaultLang === 'zh' ? '状态码' : 'Status code' },
        { key: '3', name: 'data', type: '[object]', required: 'true', description: defaultLang === 'zh' ? '返回数据' : 'Return data' },
        { key: '4', name: 'createrTime', type: 'null', required: 'true', description: defaultLang === 'zh' ? '创建时间' : 'Creation time' },
        { key: '5', name: 'flowOverdueChange', type: 'integer', required: 'true', description: defaultLang === 'zh' ? '数据变动量' : 'Data change amount' }
      ],
      
      // 获取子账号代理链接请求参数
      proxyListParams: [
        { key: '1', name: 'uname', location: 'query', type: 'string', required: '是', description: defaultLang === 'zh' ? '子账户名称' : 'Sub-account name' },
        { key: '2', name: 'time', location: 'query', type: 'integer', required: '是', description: defaultLang === 'zh' ? '代理链接持续时间' : 'Proxy link duration' },
        { key: '3', name: 'num', location: 'query', type: 'integer', required: '是', description: defaultLang === 'zh' ? '获取的代理链接条数' : 'Number of proxy links to get' },
        { key: '4', name: 'country', location: 'query', type: 'string', required: '是', description: defaultLang === 'zh' ? '需要代理的城市' : 'City to be proxied' },
        { key: '5', name: 'uid', location: 'query', type: 'integer', required: '是', description: defaultLang === 'zh' ? '登录用户的id' : 'Logged-in user id' },
        { key: '6', name: 'sign', location: 'query', type: 'string', required: '否', description: defaultLang === 'zh' ? '签名' : 'Signature' }
      ],
      
      // 获取子账号代理链接返回数据结构
      proxyListResponseData: [
        { key: '1', name: 'msg', type: 'string', required: 'true', description: defaultLang === 'zh' ? '消息' : 'Message' },
        { key: '2', name: 'code', type: 'integer', required: 'true', description: defaultLang === 'zh' ? '状态码' : 'Status code' },
        { key: '3', name: 'data', type: '[string]', required: 'true', description: defaultLang === 'zh' ? '返回数据' : 'Return data' },
        { key: '4', name: 'string', type: 'string', required: 'true', description: defaultLang === 'zh' ? '代理链接' : 'Proxy link' }
      ],
      
      // 通用返回数据结构
      commonResponseData: [
        { key: '1', name: 'code', type: 'integer', required: 'true', description: defaultLang === 'zh' ? '状态码' : 'Status code' },
        { key: '2', name: 'msg', type: 'string', required: 'true', description: defaultLang === 'zh' ? '消息' : 'Message' }
      ]
    };
  },
  methods: {
    // 可以在这里添加需要的方法
  }
};
</script>

<style scoped>
.api-documentation {
  padding: 20px;
}

.api-detail {
  margin-top: 20px;
}

.api-path {
  font-family: monospace;
  color: #1890ff;
  margin-bottom: 10px;
  font-size: 16px;
}

.api-signature {
  background-color: #fff8e6;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 10px;
}
</style>